"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyQuotation = void 0;
var QuotationStatus_1 = require("./QuotationStatus");
var Customer_1 = require("./Customer");
var LegalEntity_1 = require("./LegalEntity");
var QuotationSummaryResponse_1 = require("./QuotationSummaryResponse");
var QuotationUser_1 = require("./QuotationUser");
var PaymentMethod_1 = require("./PaymentMethod");
var customerTypes_1 = require("../constants/customerTypes");
var QuotationProfile_1 = require("./QuotationProfile");
function makeEmptyQuotation() {
    return {
        id: -1,
        version: 0,
        notes: null,
        discountPrice: 0,
        policyNumber: null,
        createdAt: '',
        sendEmailCreatorUser: true,
        expireAt: '',
        updatedAt: null,
        createdBy: '',
        updatedBy: null,
        customerType: customerTypes_1.NATURAL_PERSON,
        customer: Customer_1.makeEmptyCustomer(),
        legalEntity: LegalEntity_1.makeEmptyLegalEntity(),
        summary: QuotationSummaryResponse_1.makeEmptyQuotationSummary(),
        units: [],
        status: QuotationStatus_1.makeEmptyQuotationStatus(),
        productId: '',
        code: '',
        urlSalt: '',
        packageOption: 0,
        user: QuotationUser_1.makeEmptyQuotationUser(),
        paymentMethods: PaymentMethod_1.makeEmptyPaymentMethod(),
        hasMultipleOptions: false,
        operationNumber: 0,
        policyId: 0,
        brokerLicense: '',
        isAutoPx: true,
        issuedBy: QuotationUser_1.makeEmptyQuotationUser(),
        quotationProfile: QuotationProfile_1.makeEmptyQuotationProfile(),
        additionalBrokers: [],
        origin: '',
        pricingPaymentMethods: [],
        additionalDocuments: [],
        agencyId: '',
        parentQuotation: 0,
        copyOrder: 0,
    };
}
exports.makeEmptyQuotation = makeEmptyQuotation;
//# sourceMappingURL=Quotation.js.map